import { Fatura, Contrato } from '@/types/database'

export type CalculatedStatus = 'ativo' | 'inadimplente' | 'pendente_adesao' | 'cancelado' | 'suspenso'

export function calculateContratoStatus(contrato: any, faturas: any[]): CalculatedStatus {
    const status = contrato.status

    if (status === 'cancelado') return 'cancelado'
    if (status === 'suspenso') return 'suspenso'

    // Busca faturas deste contrato específico e que REALMENTE existam no Asaas (tenham asaas_payment_id)
    // Isso ignora as faturas "fantasmas" que o sistema antigo gerava localmente sem vínculo real.
    const faturasContrato = faturas.filter(f => f.contrato_id === contrato.id && !!f.asaas_payment_id)

    // 1. Prioridade: Se houver ADESÃO pendente (local ou no status do banco), ele está pendente de adesão.
    // Isso evita que faturas de mensalidade "atrasadas" marquem o contrato como inadimplente antes dele ser ativado.
    const temAdesaoPendente = faturasContrato.some(f => (f.tipo === 'adesao' || f.metadata?.tipo_adesao) && f.status !== 'paga')
    
    if (status === 'pendente_adesao' || temAdesaoPendente) return 'pendente_adesao'
    if (status === 'pendente_mensalidade') return status as any

    // 2. Inadimplência: Só marcamos como inadimplente se houver atraso REAL em fatura com vínculo no Asaas
    const temAtraso = faturasContrato.some(f => f.status === 'atrasada')
    
    // Se o banco diz que está inadimplente, ou se o banco diz que está ativo mas tem boleto atrasado no Asaas
    if (status === 'inadimplente' || (status === 'ativo' && temAtraso)) {
        return 'inadimplente'
    }

    return status === 'ativo' ? 'ativo' : status
}

export function translateCalculatedStatus(status: CalculatedStatus): string {
    const map: Record<string, string> = {
        ativo: 'Ativo',
        inadimplente: 'Inadimplente',
        pendente_adesao: 'Aguardando Adesão',
        pendente_mensalidade: 'Aguard. Pagamento',
        cancelado: 'Cancelado',
        suspenso: 'Suspenso'
    }
    return map[status] || status
}
